export default './wheels/streamlit-1.62.0-cp313-none-any.whl'